/**
 * Admin V3 — Onboarding module — Search bar (minimal)
 *
 * GOVERNANCE MEANING: pending-approvals queue search.
 *
 * Layout (left → right):
 *   [Search input] [Result counter]
 *
 * NO status filter (backend GET /admin/beta/pending-drivers is fixed-filter
 * to approval_status="pending"; admin.py:472-475).
 * NO CSV export button (backend exposes none).
 *
 * Search: parent owns the debounced state; this component renders only the
 * input and emits onChange. Filtering is applied client-side over the
 * loaded page (transparent to the operator via the placeholder copy).
 *
 * Class strings mirror DriversListSearchBar (Phase 2.3) for operator UX
 * consistency across V3 modules.
 */

import React from 'react';
import { Search, X } from 'lucide-react';
import { t } from '../../i18n';

const OnboardingListSearchBar = ({
  search,
  onSearchChange,
  resultsCount,
  isFilterActive,
  loading,
  locale = 'fr',
}) => {
  const resultsCountText = t('onboarding.results.count', locale).replace('{n}', String(resultsCount));

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search (client-side, page-scoped) */}
      <div className="relative flex-1 max-w-md min-w-[240px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('onboarding.search.placeholder', locale)}
          data-testid="adminv3-onboarding-search"
          className="w-full rounded-xl border border-slate-200 bg-slate-50 py-2.5 pl-10 pr-9 text-sm text-slate-900 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-100"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
            data-testid="adminv3-onboarding-search-clear"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Result counter (only when search is active and not loading) */}
      {isFilterActive && !loading && (
        <span className="text-sm text-slate-400" data-testid="adminv3-onboarding-results-count">
          {resultsCountText}
        </span>
      )}
    </div>
  );
};

export default OnboardingListSearchBar;
